import React from "react";

interface IProps {
  className: string;
  text: string;
}

export const CopyRightFooter: React.FC<IProps> = ({ className, text }) => {
  return (
    <footer className={className}>
      &copy; {text}, {new Date().getFullYear()}
    </footer>
  );
};

export default CopyRightFooter;
